import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit
} from '@angular/core';
import * as c3 from 'c3';
import { GraphUtilsService } from '../../services/graph-utils.service';
import { DataService } from '../../services/data.service';

@Component({
    selector: 'app-c3-ega-bar',
    templateUrl: './c3-ega-bar.component.html',
    styleUrls: ['./c3-ega-bar.component.scss'],
    standalone: false
})
export class C3EgaBarComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() barData: any;
  @Input() colour: any;

  chart: any = null;
  height: any = 200;
  subscription: any;
  constructor(
    private elRef: ElementRef,
    private graphUtil: GraphUtilsService,
    private dataSer: DataService
  ) {
    this.subscription = dataSer.events.subscribe(this.replotGraphEventSubscription);
  }

  replotGraphEventSubscription = (res: any) => {
    if (res.name === 'replotGraph') {
      let timeoutval = 0;
      if (res.args && res.args[0] === 'menuToggle') {
        timeoutval = 101;
      }
      setTimeout(() => {
        this.checkAndReplotGraph();
      }, timeoutval);
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    //  changed to fix memory leak
    if (this.chart) {
      this.chart.destroy();
    }
    this.checkAndReplotGraph();
  }

  ngAfterViewInit(): void {
    this.checkAndReplotGraph();
  }

  checkAndReplotGraph() {
    this.height = this.barData.length > 0 ? this.barData[0].height : 0;
    this.generateChart(this.barData);
  }

  generateChart = (data) => {
    this.chart = c3.generate({
      bindto: this.elRef.nativeElement.children[0],
      size: {
        height: this.height
      },
      data: {
        columns: [
          ['value', ...this.barData.map(elem => elem.value)]
        ],
        type: 'bar',
        colors: {
          value: this.colour
        },
      },
      bar: {
        width: 20
      },
      axis: {
        rotated: true,
        x: {
          show: false
        },
        y: {
          show: true
        }
      },
      legend: {
        show: false
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

